// Line Items — frontend API surface (/api/line-items, server/routes.js).

import { client } from '@platform/http/api-client';

const enc = encodeURIComponent;
const data = (p) => p.then((r) => r.data);

const lineItemsApi = {
  // admin: a Line items field's definition
  getDefinition: (fieldId) => data(client.get(`/api/line-items/fields/${enc(fieldId)}/definition`)),
  saveDefinition: (fieldId, definition) => data(client.put(`/api/line-items/fields/${enc(fieldId)}/definition`, { definition })),
  versions: (fieldId) => data(client.get(`/api/line-items/fields/${enc(fieldId)}/versions`)),
  preview: (definition, lines, rates) => data(client.post('/api/line-items/preview', { definition, lines, rates })),
  // one field on one work item
  forField: (key, fieldId) => data(client.get(`/api/line-items/issue/${enc(key)}/field/${enc(fieldId)}`)),
  addLine: (key, fieldId, line) => data(client.post(`/api/line-items/issue/${enc(key)}/field/${enc(fieldId)}/lines`, line)),
  reorder: (key, fieldId, ids) => data(client.put(`/api/line-items/issue/${enc(key)}/field/${enc(fieldId)}/order`, { ids })),
  // a checklist: every open line answered done (the view's allDone button)
  answerAll: (key, fieldId, today) => data(client.put(`/api/line-items/issue/${enc(key)}/field/${enc(fieldId)}/answer-all`, { today })),
  updateLine: (id, line) => data(client.put(`/api/line-items/lines/${enc(id)}`, line)),
  deleteLine: (id) => data(client.delete(`/api/line-items/lines/${enc(id)}`)),
  // an editable percent total's rate on this work item (null = back to the default)
  setRate: (key, fieldId, totalId, rate) => data(client.put(`/api/line-items/issue/${enc(key)}/field/${enc(fieldId)}/rate/${enc(totalId)}`, { rate })),
  forProduct: (key) => data(client.get(`/api/line-items/product/${enc(key)}`)),
  // the document's toggle (a quote → an order) and a fillFromLast column's last value
  // (signature: the approver's, when the document is signed to convert)
  convert: (key, fieldId, to, signature) => data(client.post(`/api/line-items/issue/${enc(key)}/field/${enc(fieldId)}/convert`, signature ? { to, signature } : { to })),
  // the signed approval: sign a step / clear one's own signature
  sign: (key, fieldId, step, signature) => data(client.post(`/api/line-items/issue/${enc(key)}/field/${enc(fieldId)}/sign/${enc(step)}`, { signature })),
  clearSignature: (key, fieldId, step) => data(client.delete(`/api/line-items/issue/${enc(key)}/field/${enc(fieldId)}/sign/${enc(step)}`)),
  // a document's QR code: base64 PNG
  qr: (text) => data(client.get('/api/line-items/qr', { params: { text } })).then((r) => r.png || null),
  lastValue: (fieldId, productKey, columnId) => data(client.get(`/api/line-items/fields/${enc(fieldId)}/last-value`, { params: { product: productKey, column: columnId } })),
  // what products bring to a line ({ fill, max } per key) and lines not saved yet, computed
  productInfo: (fieldId, keys) => data(client.get(`/api/line-items/fields/${enc(fieldId)}/product-info`, { params: { products: keys.join(',') } })).then((r) => r.info || {}),
  draft: (fieldId, lines) => data(client.post(`/api/line-items/fields/${enc(fieldId)}/draft`, { lines })),
};

export default lineItemsApi;
